<template>
	<div class="table-responsive">
		<table class="table table-sm table-striped table-bordered mb-0">
			<tbody>
				<tr>
					<th>Key</th>
					<th>Ability</th>
					<th class="input-column-xs">Base</th>
					<th class="input-column-xs">Race</th>
					<th class="input-column-xs">Theme</th>
					<th class="input-column-xs">Upgrades</th>
					<th class="input-column-xs">Temp</th>
					<th class="input-column-xs">Increases</th>
					<th class="input-column-xs">Total</th>
					<th class="input-column-xs">Modifier</th>
				</tr>
				<tr v-for="(score, ability) in totalScores" :key="`ability-score-${ability}`">
					<td><input type="radio" :value="ability" v-model="keyAbility"/></td>
					<th scope="row">{{ability}}</th>
					<td><input type="number" class="form-control form-control-sm" v-model.number="abilityScores.base[ability]" /></td>
					<td><input type="number" class="form-control form-control-sm" v-model.number="abilityScores.race[ability]" /></td>
					<td><input type="number" class="form-control form-control-sm" v-model.number="abilityScores.theme[ability]" /></td>
					<td><input type="number" class="form-control form-control-sm" v-model.number="abilityScores.upgrades[ability]" /></td>
					<td><input type="number" class="form-control form-control-sm" v-model.number="abilityScores.temporary[ability]" /></td>
					<td><input type="number" disabled class="form-control form-control-sm disabled" :value="abilityIncreases[ability]" /></td>
					<td class="table-active">
						<input type="number" disabled class="form-control form-control-sm disabled bold" :value="totalScores[ability]" />
					</td>
					<td><input type="number" disabled class="form-control form-control-sm disabled" :value="abilityMods[ability]" /></td>
				</tr>
				<tr>
					<th scope="row" colspan="2" class="text-right">Point Buy Total</th>
					<td>{{pointBuyTotal}}</td>
					<td colspan="7"></td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	computed: {
		abilityScores: {
			get: function(){
				return this.$store.getters['character/abilityScores/breakdown']
			},
			set: function(scores){
				this.$store.commit('character/abilityScores/setScores',scores)
			}
		},
		totalScores: function(){
			return this.$store.getters['character/abilityScores/abilityScores']
		},
		abilityMods: function(){
			return this.$store.getters['character/abilityScores/abilityMods']
		},
		pointBuyTotal: function(){
			var total = 0
			for(const score in this.abilityScores.base){
				total += (this.abilityScores.base[score]-10)
			}
			return total
		},
		keyAbility: {
			get: function(){
				return this.$store.getters['character/abilityScores/key']
			},
			set: function(value){
				this.$store.commit('character/abilityScores/setKey',value)
			}
		},
		abilityIncreases: function(){
			return this.$store.getters['character/abilityScores/abilityIncreasesAtLevel'](this.$store.getters['currentLevel'])
		}
	}
}
</script>

<style scoped>
input.bold {
	font-weight: bold;
}
</style>